var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.openFileDialog}},[_c('v-icon',[_vm._v("mdi-plus")])],1),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }